import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _bulkUpdateTicketReservationTagsByFilterRequest = {};
var _bulkUpdateTicketReservationTagsByFilterResponse = {};
var _bulkUpdateTicketReservationTagsRequest = {};
var _bulkUpdateTicketReservationTagsResponse = {};
var _cancelTicketReservationRequest = {};
var _cancelTicketReservationResponse = {
    ticketReservation: '_ticketReservation',
};
var _createCheckoutRequest = {};
var _createCheckoutResponse = {};
var _createTicketReservationRequest = {
    ticketReservation: '_ticketReservation',
};
var _createTicketReservationResponse = {
    ticketReservation: '_ticketReservation',
};
var _deleteCurrentTicketReservationRequest = {};
var _deleteCurrentTicketReservationResponse = {
    ticketReservation: '_ticketReservation',
};
var _deleteTicketReservationRequest = {};
var _deleteTicketReservationResponse = {
    ticketReservation: '_ticketReservation',
};
var _getCurrentTicketReservationRequest = {};
var _getCurrentTicketReservationResponse = {
    ticketReservation: '_ticketReservation',
};
var _getTicketReservationRequest = {};
var _getTicketReservationResponse = {
    ticketReservation: '_ticketReservation',
};
var _ticketReservation = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    expirationDate: 'google.protobuf.Timestamp',
};
var _updateCurrentTicketReservationRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    ticketReservation: '_ticketReservation',
};
var _updateCurrentTicketReservationResponse = {
    ticketReservation: '_ticketReservation',
};
var _updateTicketReservationRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    ticketReservation: '_ticketReservation',
};
var _updateTicketReservationResponse = {
    ticketReservation: '_ticketReservation',
};
function resolveWixEventsTicketreservationsV1TicketReservationManagementUrl(opts) {
    var domainToMappings = {
        _: [
            {
                srcPath: '/_api/events-ticket-reservations',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/events-ticket-reservations',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/events-ticket-reservations',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/events/v1/ticket-reservations',
                destPath: '/v1/ticket-reservations',
            },
            {
                srcPath: '/events/v1/bulk/ticket-reservations',
                destPath: '/v1/bulk/ticket-reservations',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveWixEventsTicketreservationsV1CheckoutServiceUrl(opts) {
    var domainToMappings = {
        _: [
            {
                srcPath: '/_api/events-ticket-reservations',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/events-ticket-reservations',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/events-ticket-reservations',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/events/v1/ticket-reservations',
                destPath: '/v1/ticket-reservations',
            },
            {
                srcPath: '/events/v1/bulk/ticket-reservations',
                destPath: '/v1/bulk/ticket-reservations',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates an e-comm checkout from reservation id. */
export function createCheckout(payload) {
    var _a = serializer(_createCheckoutRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createCheckoutResponse, {}).fromJSON;
    function __createCheckout(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.ticket_reservation',
            method: 'POST',
            methodFqn: 'wix.events.ticketreservations.v1.CheckoutService.CreateCheckout',
            url: resolveWixEventsTicketreservationsV1CheckoutServiceUrl({
                protoPath: '/v1/ticket-reservations/{ticketReservationId}/checkout',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createCheckout.fromReq = fromReq;
    __createCheckout.__isAmbassador = true;
    return __createCheckout;
}
/** Creates a TicketReservation. */
export function createTicketReservation(payload) {
    var _a = serializer(_createTicketReservationRequest, { _ticketReservation: _ticketReservation }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createTicketReservationResponse, {
        _ticketReservation: _ticketReservation,
    }).fromJSON;
    function __createTicketReservation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.ticket_reservation',
            method: 'POST',
            methodFqn: 'wix.events.ticketreservations.v1.TicketReservationManagement.CreateTicketReservation',
            url: resolveWixEventsTicketreservationsV1TicketReservationManagementUrl({
                protoPath: '/v1/ticket-reservations',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createTicketReservation.fromReq = fromReq;
    __createTicketReservation.__isAmbassador = true;
    return __createTicketReservation;
}
/** Retrieves a TicketReservation. */
export function getTicketReservation(payload) {
    var _a = serializer(_getTicketReservationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getTicketReservationResponse, {
        _ticketReservation: _ticketReservation,
    }).fromJSON;
    function __getTicketReservation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.ticket_reservation',
            method: 'GET',
            methodFqn: 'wix.events.ticketreservations.v1.TicketReservationManagement.GetTicketReservation',
            url: resolveWixEventsTicketreservationsV1TicketReservationManagementUrl({
                protoPath: '/v1/ticket-reservations/{ticketReservationId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getTicketReservation.fromReq = fromReq;
    __getTicketReservation.__isAmbassador = true;
    return __getTicketReservation;
}
/** Retrieves the current site visitor's TicketReservation. */
export function getCurrentTicketReservation(payload) {
    var _a = serializer(_getCurrentTicketReservationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getCurrentTicketReservationResponse, { _ticketReservation: _ticketReservation }).fromJSON;
    function __getCurrentTicketReservation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.ticket_reservation',
            method: 'GET',
            methodFqn: 'wix.events.ticketreservations.v1.TicketReservationManagement.GetCurrentTicketReservation',
            url: resolveWixEventsTicketreservationsV1TicketReservationManagementUrl({
                protoPath: '/v1/ticket-reservations/current',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getCurrentTicketReservation.fromReq = fromReq;
    __getCurrentTicketReservation.__isAmbassador = true;
    return __getCurrentTicketReservation;
}
/**
 * Updates a TicketReservation.
 *
 *
 * Each time the TicketReservation is updated,
 * `revision` increments by 1.
 * The current `revision` must be passed when updating the TicketReservation.
 * This ensures you're working with the latest TicketReservation
 * and prevents unintended overwrites.
 */
export function updateTicketReservation(payload) {
    var _a = serializer(_updateTicketReservationRequest, { _ticketReservation: _ticketReservation }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateTicketReservationResponse, {
        _ticketReservation: _ticketReservation,
    }).fromJSON;
    function __updateTicketReservation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.ticket_reservation',
            method: 'PATCH',
            methodFqn: 'wix.events.ticketreservations.v1.TicketReservationManagement.UpdateTicketReservation',
            url: resolveWixEventsTicketreservationsV1TicketReservationManagementUrl({
                protoPath: '/v1/ticket-reservations/{ticketReservation.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateTicketReservation.fromReq = fromReq;
    __updateTicketReservation.__isAmbassador = true;
    return __updateTicketReservation;
}
/**
 * Updates the current site visitor's TicketReservation.
 *
 * Each time the TicketReservation is updated,
 * `revision` increments by 1.
 * The current `revision` must be passed when updating the TicketReservation.
 * This ensures you're working with the latest TicketReservation
 * and prevents unintended overwrites.
 */
export function updateCurrentTicketReservation(payload) {
    var _a = serializer(_updateCurrentTicketReservationRequest, { _ticketReservation: _ticketReservation }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateCurrentTicketReservationResponse, { _ticketReservation: _ticketReservation }).fromJSON;
    function __updateCurrentTicketReservation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.ticket_reservation',
            method: 'PATCH',
            methodFqn: 'wix.events.ticketreservations.v1.TicketReservationManagement.UpdateCurrentTicketReservation',
            url: resolveWixEventsTicketreservationsV1TicketReservationManagementUrl({
                protoPath: '/v1/ticket-reservations/current',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateCurrentTicketReservation.fromReq = fromReq;
    __updateCurrentTicketReservation.__isAmbassador = true;
    return __updateCurrentTicketReservation;
}
/**
 * Deletes a TicketReservation.
 * Deleting a TicketReservation permanently removes them from the TicketReservation List.
 */
export function deleteTicketReservation(payload) {
    var _a = serializer(_deleteTicketReservationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteTicketReservationResponse, {
        _ticketReservation: _ticketReservation,
    }).fromJSON;
    function __deleteTicketReservation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.ticket_reservation',
            method: 'DELETE',
            methodFqn: 'wix.events.ticketreservations.v1.TicketReservationManagement.DeleteTicketReservation',
            url: resolveWixEventsTicketreservationsV1TicketReservationManagementUrl({
                protoPath: '/v1/ticket-reservations/{ticketReservationId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteTicketReservation.fromReq = fromReq;
    __deleteTicketReservation.__isAmbassador = true;
    return __deleteTicketReservation;
}
/**
 * Deletes a current visitor's TicketReservation.
 * Deleting a TicketReservation permanently removes them from the TicketReservation List.
 */
export function deleteCurrentTicketReservation(payload) {
    var _a = serializer(_deleteCurrentTicketReservationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteCurrentTicketReservationResponse, { _ticketReservation: _ticketReservation }).fromJSON;
    function __deleteCurrentTicketReservation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.ticket_reservation',
            method: 'DELETE',
            methodFqn: 'wix.events.ticketreservations.v1.TicketReservationManagement.DeleteCurrentTicketReservation',
            url: resolveWixEventsTicketreservationsV1TicketReservationManagementUrl({
                protoPath: '/v1/ticket-reservations/current',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteCurrentTicketReservation.fromReq = fromReq;
    __deleteCurrentTicketReservation.__isAmbassador = true;
    return __deleteCurrentTicketReservation;
}
/**
 * Synchronously update tags on multiple TicketReservations, by list of TicketReservations ids
 * A tag that appears both in the list of assign and unassign tags, will be assigned
 */
export function bulkUpdateTicketReservationTags(payload) {
    var _a = serializer(_bulkUpdateTicketReservationTagsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateTicketReservationTagsResponse, {}).fromJSON;
    function __bulkUpdateTicketReservationTags(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.ticket_reservation',
            method: 'POST',
            methodFqn: 'wix.events.ticketreservations.v1.TicketReservationManagement.BulkUpdateTicketReservationTags',
            url: resolveWixEventsTicketreservationsV1TicketReservationManagementUrl({
                protoPath: '/v1/bulk/ticket-reservations/update-tags',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateTicketReservationTags.fromReq = fromReq;
    __bulkUpdateTicketReservationTags.__isAmbassador = true;
    return __bulkUpdateTicketReservationTags;
}
/**
 * Asynchronously update tags on multiple TicketReservations, by provided filter
 * An empty filter will update all TicketReservations
 * A tag that appears both in the list of assign and unassign tags, will be assigned
 */
export function bulkUpdateTicketReservationTagsByFilter(payload) {
    var _a = serializer(_bulkUpdateTicketReservationTagsByFilterRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateTicketReservationTagsByFilterResponse, {}).fromJSON;
    function __bulkUpdateTicketReservationTagsByFilter(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.ticket_reservation',
            method: 'POST',
            methodFqn: 'wix.events.ticketreservations.v1.TicketReservationManagement.BulkUpdateTicketReservationTagsByFilter',
            url: resolveWixEventsTicketreservationsV1TicketReservationManagementUrl({
                protoPath: '/v1/bulk/ticket-reservations/update-tags-by-filter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateTicketReservationTagsByFilter.fromReq = fromReq;
    __bulkUpdateTicketReservationTagsByFilter.__isAmbassador = true;
    return __bulkUpdateTicketReservationTagsByFilter;
}
/** Cancels a TicketReservation */
export function cancelTicketReservation(payload) {
    var _a = serializer(_cancelTicketReservationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cancelTicketReservationResponse, {
        _ticketReservation: _ticketReservation,
    }).fromJSON;
    function __cancelTicketReservation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.ticket_reservation',
            method: 'POST',
            methodFqn: 'wix.events.ticketreservations.v1.TicketReservationManagement.CancelTicketReservation',
            url: resolveWixEventsTicketreservationsV1TicketReservationManagementUrl({
                protoPath: '/v1/ticket-reservations/{ticketReservationId}/cancel',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cancelTicketReservation.fromReq = fromReq;
    __cancelTicketReservation.__isAmbassador = true;
    return __cancelTicketReservation;
}
//# sourceMappingURL=http.impl.js.map